import { ApplicationConfig, importProvidersFrom, inject, isDevMode, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './services/app-title.strategy';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiLoaderInterceptorService } from './services/api-loader-interceptor.service';
import { provideStore, Store } from '@ngrx/store';
import { connectAuthSession } from './store/auth/auth-session';
import { provideEffects } from '@ngrx/effects';
import { appEffects } from './store/app-effect';
import { reducers } from './store/app-reducers';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServerModule } from '@angular/platform-server';
import { provideToastr } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from './environment/environment';
import { withEnabledBlockingInitialNavigation, withPreloading } from '@angular/router';
import { SelectivePreloadingStrategy } from './services/selective-preloading.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // provideRouter(routes),
    // Portal code for routes with data.preload downloads in the background (e.g. during login)
    provideRouter(routes, withEnabledBlockingInitialNavigation(), withPreloading(SelectivePreloadingStrategy)),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi()),
    ApiService,
    provideStore(reducers),
    // Login session lives in the store only; wire the sync helpers before any guard runs
    provideAppInitializer(() => connectAuthSession(inject(Store))),
    provideEffects(appEffects),
    ServerModule,
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      // Never show the login token in Redux DevTools
      stateSanitizer: (state: any) => state?.auth?.token
        ? { ...state, auth: { ...state.auth, token: '[hidden]' } }
        : state,
      actionSanitizer: (action: any) => action?.type === '[Auth] Set Token'
        ? { ...action, token: action.token ? '[hidden]' : null }
        : action,
    }),
    provideToastr({
      positionClass: "toast-top-right",
      closeButton: true,
      progressBar: true,
      newestOnTop: true,
      maxOpened: 4,
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true,
      toastClass: 'custom-toast',
      titleClass: 'custom-toast-title',
      messageClass: 'custom-toast-msg',
      easeTime: 500,
      timeOut: 3000,
      extendedTimeOut: 3000
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiLoaderInterceptorService,
      multi: true
    },
    provideAnimationsAsync(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        isolate: false
      })
    ),
  ],

};
